(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.es-best-sellers__swiper').forEach((element) => {
      const nextButton = document.querySelector(`[data-es-best-sellers-next="${element.id}"]`);
      if (!nextButton || typeof Swiper === 'undefined') return;

      const swiper = new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: parseInt(getComputedStyle(element).getPropertyValue('--es-best-sellers-slide-gap')) || 16,
        navigation: {
          nextEl: nextButton,
        },
        breakpoints: {
          990: {
            slidesPerGroup: 1,
          },
        },
      });

      const updateNav = () => {
        nextButton.disabled = swiper.isEnd;
      };

      swiper.on('slideChange', updateNav);
      swiper.on('resize', updateNav);
      updateNav();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-parallax-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var rellax = new Rellax('.es-parallax .background-image-container img', {
      center:true,
      horizontal:true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    (() => {
      const thumbs = new Swiper('.es-testimonial-texts', {
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 600,
      });

      const slider = new Swiper('.es-testimonial-medias', {
        slidesPerView: 'auto',
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        watchSlidesProgress: true,
        on: {
          slideChange(sw) {
            thumbs.slideTo(sw.realIndex);
          },
        },
      });

      /* slider.on('click', (sw) => {
        if (!sw.clickedSlide) return;
        const realIndex = parseInt(sw.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (!isNaN(realIndex)) {
          sw.slideToLoop(realIndex);
        }
      }); */
    })()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  const syncProductListFeatureCardHeights = (section) => {
    if (!window.matchMedia('(min-width: 750px)').matches) {
      section
        .querySelectorAll('.product-list-swiper__slide--feature .es-best-sellers__feature-card')
        .forEach((card) => {
          card.style.minHeight = '';
        });
      return;
    }

    const featureCard = section.querySelector(
      '.product-list-swiper__slide--feature .es-best-sellers__feature-card, .resource-list__item--feature .es-best-sellers__feature-card'
    );
    const productCards = section.querySelectorAll(
      '.product-list-swiper__slide:not(.product-list-swiper__slide--feature) .es-best-sellers__product-card, .product-list-swiper__slide:not(.product-list-swiper__slide--feature) .product-card, .product-list-swiper__slide:not(.product-list-swiper__slide--feature) product-card-link, .resource-list__item:not(.resource-list__item--feature) .es-best-sellers__product-card, .resource-list__item:not(.resource-list__item--feature) .product-card, .resource-list__item:not(.resource-list__item--feature) product-card-link'
    );

    if (!featureCard || !productCards.length) return;

    let maxHeight = 0;
    productCards.forEach((card) => {
      maxHeight = Math.max(maxHeight, card.getBoundingClientRect().height);
    });

    if (maxHeight > 0) {
      featureCard.style.minHeight = `${Math.ceil(maxHeight)}px`;
    }
  };

  const initProductListSwiper = (element) => {
    if (typeof Swiper === 'undefined') return null;

    if (element.swiper) {
      element.swiper.destroy(true, true);
    }

    const prevButton = document.querySelector(`[data-swiper-prev="${element.id}"]`);
    const nextButton = document.querySelector(`[data-swiper-next="${element.id}"]`);
    const gap = parseInt(element.dataset.gap, 10) || 16;
    const section = element.closest('.section-resource-list');

    const swiper = new Swiper(element, {
      slidesPerView: 'auto',
      spaceBetween: gap,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.65,
      navigation:
        prevButton && nextButton
          ? {
              prevEl: prevButton,
              nextEl: nextButton,
            }
          : undefined,
    });

    const syncHeights = () => {
      if (section) syncProductListFeatureCardHeights(section);
    };

    swiper.on('slideChange', syncHeights);
    swiper.on('resize', syncHeights);
    syncHeights();

    return swiper;
  };

  const setupProductListSections = () => {
    document.querySelectorAll('.product-list-swiper').forEach((element) => {
      initProductListSwiper(element);
    });

    document
      .querySelectorAll('.section-resource-list--has-feature-card:not(:has(.product-list-swiper))')
      .forEach((section) => {
        syncProductListFeatureCardHeights(section);
      });
  };

  setupProductListSections();
  document.addEventListener('shopify:section:load', setupProductListSections);

  } catch(e) { console.error(e); }
})();
})();
